import React from "react";

const Pagination = ({ page, totalPages, totalCount, pageSize = 10, onPageChange }) => {
    if (totalPages <= 1) return null;

    const start = (page - 1) * pageSize + 1;
    const end = Math.min(page * pageSize, totalCount);

    const getPages = () => {
        const pages = [];
        for (let i = 1; i <= totalPages; i++) pages.push(i);
        return pages;
    };

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between border-t border-gray-200 bg-white px-1 py-1 sm:px-6">

            {/* Info */}
            <div className="text-sm text-gray-700 mb-2 sm:mb-0">
                Showing <span className="font-medium">{start}</span> to <span className="font-medium">{end}</span> of <span className="font-medium">{totalCount}</span> results
            </div>

            {/* Pagination Controls */}
            <div className="flex items-center gap-1">

                {/* Prev */}
                <button
                    onClick={() => onPageChange(page - 1)}
                    disabled={page === 1}
                    className="relative inline-flex items-center rounded-l-md px-1 py-1 text-gray-400 border border-gray-300 hover:bg-gray-50 focus:outline-none focus:z-20 disabled:bg-gray-100 disabled:text-gray-400"
                >
                    <span className="sr-only">Previous</span>
                    <i className="fas fa-chevron-left"></i>
                </button>

                {/* Page Numbers */}
                {getPages().map(p => (
                    <button
                        key={p}
                        onClick={() => onPageChange(p)}
                        aria-current={p === page ? "page" : undefined}
                        className={`relative inline-flex items-center px-1 py-1 border text-sm font-medium focus:z-20
              ${p === page
                                ? "z-10 bg-[var(--base-color)] text-white border-[var(--base-color)]"
                                : "bg-white text-gray-900 border-gray-300 hover:bg-gray-50"
                            }
            `}
                    >
                        {p}
                    </button>
                ))}

                {/* Next */}
                <button
                    onClick={() => onPageChange(page + 1)}
                    disabled={page === totalPages}
                    className="relative inline-flex items-center rounded-r-md px-1 py-1 text-gray-400 border border-gray-300 hover:bg-gray-50 focus:outline-none focus:z-20 disabled:bg-gray-100 disabled:text-gray-400"
                >
                    <span className="sr-only">Next</span>
                    <i className="fas fa-chevron-right"></i>
                </button>

            </div>
        </div>
    );
};

export default Pagination;